import { createRouter, type RouterHistory } from '@tanstack/react-router';
import type { QueryClient } from '@tanstack/react-query';
import { LoadingState } from '@salesbee/ui';
import { authRoutes, onboardingRoutes } from '../modules/auth/routes';
import { appRoutes } from '../modules/routes';
import { appLayoutRoute, bareAuthedRoute, publicLayoutRoute, rootRoute } from './parents';

export const routeTree = rootRoute.addChildren([
  publicLayoutRoute.addChildren([...authRoutes]),
  bareAuthedRoute.addChildren([...onboardingRoutes]),
  appLayoutRoute.addChildren([...appRoutes]),
]);

export function createAppRouter(queryClient: QueryClient, options: { history?: RouterHistory } = {}) {
  return createRouter({
    routeTree,
    ...(options.history ? { history: options.history } : {}),
    context: { queryClient },
    defaultPreload: 'intent',
    defaultPreloadStaleTime: 0,
    scrollRestoration: true,
    defaultPendingComponent: () => <LoadingState />,
  });
}

declare module '@tanstack/react-router' {
  interface Register {
    router: ReturnType<typeof createAppRouter>;
  }
}
